import React from "react"
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import * as Icons from "react-feather";
import { styles } from "./style";

interface Props extends
	WithStyles<typeof styles>
{
	label: string,
	value: boolean | undefined,
	default?: boolean,
	onChange: (value: boolean) => void,
	sidebarNote?: React.ReactNode,
}

class Component extends React.Component<Props> {
	public render() {
		const { classes, sidebarNote } = this.props;
		const value = (this.props.value !== undefined) ? this.props.value : (this.props.default || false);

		const labelStyle = {
			fontSize: '16px',
			fontWeight: 400,
			lineHeight: '20px',
			color: '#1C1B1F'
		};

		const labelContent = sidebarNote ? (
			<span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
				<span style={labelStyle}>{this.props.label}</span>
				<Mui.Tooltip title={sidebarNote} placement="right" arrow>
						<Icons.Info size={16} />
				</Mui.Tooltip>
			</span>
		) : (
			<span style={labelStyle}>{this.props.label}</span>
		);

		return (
			<Mui.FormControlLabel
				control={
					<Mui.Switch
						checked={value}
						onChange={(event) => this.props.onChange(event.target.checked)}
						color="secondary"
					/>
				}
				label={labelContent}
			/>
		);
	}
}

export const YesNoToggleField = withStyles(Component, styles);
